import React, { Component } from "react";
import L from "leaflet";
import { Marker, Popup } from "react-leaflet";

import styles from "./mapMarkerTaskTrip.module.scss";
import { poupupContent } from "../../../../services/PoupUpService/poupupService";
import getDates from "../../../../shared/services/date.service";
import geocoderService from "../../../../shared/services/geocoderService";

class MapMarkerTaskTrip extends Component {
  onClickHandler(e) {
    const { unit, point } = this.props;

    const datas = [
      { title: "Номер", value: unit.mapPositions.number },
      { title: "Транспортное средство", value: unit.title },
      { title: "Регистрационный номер", value: unit.registerNumber },
      { title: "Время", value: getDates.getDateFormat8(point.time) },
      { title: "Долгота", value: point.location.lat },
      { title: "Широта", value: point.location.long },
    ];

    geocoderService
      .reverse({ lat: point.location.lat, lon: point.location.long })
      .then((response) => {
        datas.push({ title: "Адрес", value: response.data.address });
        e.target._popup.setContent(poupupContent({ datas }));
      })
      .catch((error) => {
        e.target._popup.setContent(poupupContent({ datas }));
      });

    e.target._popup.setContent(poupupContent({ datas }));
  }

  render() {
    const { point, unit, title = "" } = this.props;

    const markerIcon = L.divIcon({
      iconSize: [53, 63],
      iconAnchor: [26, 63],
      popupAnchor: [0, -63],
      className: styles.mapStartMarker,
      html: `<div class="${styles.inner}"><div><div>${title}</div><div class="${styles.innerNumber}">${unit.mapPositions.number}</div></div></div>`,
    });

    return (
      <Marker
        position={{ lat: point.location.lat, lng: point.location.long }}
        icon={markerIcon}
        eventHandlers={{
          click: this.onClickHandler.bind(this),
        }}
      >
        {this.props.children}
        <Popup className="mapPopup" />
      </Marker>
    );
  }
}

export default React.memo(MapMarkerTaskTrip);
